module.exports = __webpack_public_path__ + "assets/img/logo.8ac6b33e.png";